import { observable, action, computed } from 'mobx';
import PromptStore from './PromptStore';
import LoadingScreenStore from './LoadingScreenStore';
import { post } from '../../../services/request';

export default class SaleUiStore {
  @observable currentPanel = '';

  @computed get showUpgrade() {
    const { round, offers } = this.root;

    const submittedOffers =
      !!offers.viewModel &&
      !!offers.viewModel.offers &&
      offers.viewModel.offers.filter((a) => a.status === 'confirmed').length;

    if (
      round.definition &&
      round.definition.type === 'simple_offer' &&
      submittedOffers >= 2
    ) {
      return true;
    }

    return false;
  }

  @computed get guideNext() {
    const { saleEdit, round, offers, isComplete, status } = this.root;

    const hasOffers =
      !!offers.viewModel &&
      !!offers.viewModel.offers &&
      offers.viewModel.offers.length > 0;

    const hasSubmittedOffers =
      !!offers.viewModel &&
      !!offers.viewModel.offers &&
      offers.viewModel.offers.filter((a) => a.status === 'confirmed').length >
        0;

    if (
      round.definition &&
      round.definition.type === 'simple_offer' &&
      status === 'started' &&
      hasOffers
    ) {
      if (hasSubmittedOffers) {
        return 'saleSimpleWizard';
      }

      return null;
    }

    if (
      (round.definition && round.definition.status === 'closed') ||
      hasOffers
    ) {
      if (
        round.definition &&
        round.definition.status === 'closed' &&
        status === 'started'
      ) {
        return 'saleWizard';
      }

      return null;
    }

    if (
      (saleEdit.offerData && Object.keys(saleEdit.offerData).length < 4) ||
      !(round.isStarted || isComplete)
    ) {
      return 'saleEdit';
    }

    if (
      round.definition &&
      round.definition.status === 'notStarted' &&
      round.definition.canStart
    )
      return 'roundStart';

    if (round.definition && round.definition.status === 'started')
      return 'roundOpen';

    if (!hasOffers) {
      return 'registration';
    }

    return null;
  }

  constructor({ root }) {
    this.root = root;
    this.prompt = new PromptStore();
    this.loading = new LoadingScreenStore();
  }

  manage = action(() => {
    this.currentPanel = 'saleManage';
  });

  notifications = action(() => {
    this.currentPanel = 'saleNotifications';
  });

  messaging = action(() => {
    this.currentPanel = 'saleMessaging';
  });

  @action editSale() {
    this.currentPanel = 'saleEdit';
  }

  @action whitelisting() {
    this.currentPanel = 'whitelisting';
  }

  @action inviteSeller() {
    this.currentPanel = 'inviteSeller';
  }

  @action inviteBuyerAgent() {
    this.currentPanel = 'inviteBuyerAgent';
  }

  @action startRound() {
    this.currentPanel = 'roundStart';
  }

  @action registerUser() {
    this.currentPanel = 'registration';
  }

  @action bulkRegistrationCsv() {
    this.currentPanel = 'bulkRegistrationCsv';
  }

  @action bulkRegistrationOnOffice() {
    this.currentPanel = 'bulkRegistrationOnOffice';
  }

  @action bulkRegistrationPropUp() {
    this.currentPanel = 'bulkRegistrationPropUp';
  }

  @action bulkRegistrationPropstack() {
    this.currentPanel = 'bulkRegistrationPropstack';
  }

  @action bulkRegistrationCrm() {
    this.currentPanel = 'bulkRegistrationCrm';
  }

  @action registerOnBehalf() {
    this.currentPanel = 'registerOnBehalf';
  }

  @action editOffer() {
    this.currentPanel = 'editOffer';
  }

  @action refuseOffer() {
    this.currentPanel = 'refuse';
  }

  @action approveRegistration() {
    this.currentPanel = 'registrationApproval';
  }

  @action offerNotifications() {
    this.currentPanel = 'offerNotifications';
  }

  @action closePanel() {
    this.currentPanel = 'none';
  }

  @action updateContact() {
    this.currentPanel = 'updateContact';
  }

  showSalePreview = action(() => {
    this.currentPanel = 'salePreview';
  });

  @action showOfferPreview() {
    this.currentPanel = 'offerPreview';
  }

  @action showBiddingHistory() {
    this.currentPanel = 'biddingHistory';
  }

  openOverview = action(async () => {
    const res = await post(
      `/api/v1/sign`,
      {
        saleId: this.root.saleId,
        template: `/api/v1/offers/{saleId}/overview?contenttype=pdf&locale=${this.root.user.claims.locale}`,
      },
      this.root.user.accessToken
    );
    window.open(res.url);
  });

  showPreviewPdf = action(() => {
    window.open(
      `/api/v1/sales/${this.root.saleId}/preview?contenttype=pdf&locale=${this.root.user.claims.locale}`
    );
  });

  showSaleWizard = action((action) => {
    window.location.href = `/dashboard/${this.root.saleId}/wizard?${
      action ? `action=${action}` : ''
    }`;
  });

  @action async printOffer() {
    const res = await post(
      `/api/v1/sign`,
      {
        saleId: this.root.saleId,
        offerId: this.root.offers.selectedOffer.buyerId,
        template: `/api/v1/offers/{saleId}/{offerId}/preview?contenttype=pdf&locale=${this.root.user.claims.locale}`,
      },
      this.root.user.accessToken
    );
    window.open(res.url);
  }

  @action auctionFinals = action(() => {
    this.currentPanel = 'auctionFinals';
  });
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/SaleUiStore.js